import { renderCell } from './cellRenderers';

import { MONITOR_PAGE_SIZE } from '~/api/monitorService';
import i18n from '~/common/helpers/i18n';
import { Table } from '~/components/Table/Table';
import { TABLE_COLUMNS } from '~/scenes/Monitor/scenes/AgentLogs/constants';
import type { AgentLogsTableRow } from '~/scenes/Monitor/scenes/AgentLogs/types';

type AgentLogsTableProps = {
  data: AgentLogsTableRow[];
  loading: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  onRowClick: (item: AgentLogsTableRow) => void;
  isRowSelected?: (item: AgentLogsTableRow) => boolean;
};

export function AgentLogsTable({
  data,
  loading,
  loadingMore,
  hasMore,
  onLoadMore,
  onRowClick,
  isRowSelected
}: AgentLogsTableProps) {
  return (
    <Table
      ariaLabel='agent-logs-table'
      data-testid='monitor-agent-logs-table-list'
      data={data}
      hideHeader={false}
      columns={TABLE_COLUMNS}
      rowsPerPage={MONITOR_PAGE_SIZE}
      isLoading={loading}
      onRowClick={onRowClick}
      isRowSelected={isRowSelected}
      renderCell={renderCell}
      useFlexLayout={false}
      variant='borderless'
      infiniteScroll={{
        hasMore,
        isLoadingMore: loadingMore,
        onLoadMore,
        loadMoreText: String(i18n.t('scenes.monitor.agentLogs.table.load_more'))
      }}
    />
  );
}
